// Memory Match — flip the cards, find every pair.
export function createMemory(host) {
  const { ctx, canvas } = host; const W = host.W, H = host.H;
  const cols = 4, rows = 4, pad = 10, top = 46;
  const cw = (W - pad * (cols + 1)) / cols, ch = (H - top - pad * (rows + 1)) / rows;
  const ICONS = ["\uD83E\uDD86", "\u2B50", "\uD83D\uDC8E", "\uD83C\uDFB5", "\uD83C\uDF69", "\uD83D\uDE80", "\uD83C\uDFA8", "\uD83D\uDC51"];
  const vals = [...ICONS, ...ICONS].sort(() => Math.random() - 0.5);
  const deck = []; for (let i = 0; i < 16; i++) { const r = (i / cols) | 0, c = i % cols; deck.push({ x: pad + c * (cw + pad), y: top + pad + r * (ch + pad), v: vals[i], up: false, done: false }); }
  const S = { score: 0, over: false, moves: 0 }; let first = null, lock = 0, flipPair = null;
  const onDown = (e) => {
    if (lock > 0) return; const rect = canvas.getBoundingClientRect(); const mx = (e.clientX - rect.left) / rect.width * W, my = (e.clientY - rect.top) / rect.height * H;
    for (const card of deck) if (!card.done && !card.up && mx > card.x && mx < card.x + cw && my > card.y && my < card.y + ch) {
      card.up = true; host.sfx.click?.();
      if (!first) first = card;
      else { S.moves++; if (first.v === card.v) { first.done = card.done = true; S.score += 20; host.sfx.coin?.(); first = null; if (deck.every((d) => d.done)) S.over = true; } else { lock = 0.8; flipPair = [first, card]; first = null; } }
      break;
    }
  };
  canvas.addEventListener("pointerdown", onDown);
  return {
    dim: "2d", w: W, h: H, controls: [], get score() { return S.score; }, get over() { return S.over; },
    destroy() { canvas.removeEventListener("pointerdown", onDown); },
    frame(dt) {
      if (lock > 0) { lock -= dt; if (lock <= 0 && flipPair) { flipPair.forEach((c) => (c.up = false)); flipPair = null; } }
      ctx.fillStyle = "#0f172a"; ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = "#fff"; ctx.font = "bold 14px monospace"; ctx.fillText("PAIRS " + deck.filter((d) => d.done).length / 2 + "/8   MOVES " + S.moves, 10, 30);
      deck.forEach((card) => {
        ctx.fillStyle = card.done ? "#065f46" : card.up ? "#334155" : "#1e293b"; ctx.fillRect(card.x, card.y, cw, ch);
        ctx.textAlign = "center"; ctx.textBaseline = "middle";
        if (card.up || card.done) { ctx.font = `${Math.min(cw, ch) * 0.5}px serif`; ctx.fillText(card.v, card.x + cw / 2, card.y + ch / 2); }
        else { ctx.fillStyle = "#22d3ee"; ctx.font = "bold 22px monospace"; ctx.fillText("?", card.x + cw / 2, card.y + ch / 2); }
        ctx.textAlign = "left"; ctx.textBaseline = "alphabetic";
      });
    },
  };
}
